import { type FormControl, type FormGroup } from '@angular/forms';

export type AnalyticsSettings = {
    googleAnalytic: boolean;
    googleAnalyticAfterPayment?: boolean;
    pixelAnalytic: boolean;
    pixelAnalyticAfterPayment?: boolean;
    googleSettings?: GoogleSettings;
    pixelSettings?: PixelSettings;
};

export type GoogleSettings = {
    category: string;
    action: string;
    label: string;
    currency?: string;
    value?: number;
    leadSource?: string;
};

export type PixelSettings = {
    type: EPixelTypes;
    typeAfterPayment?: EPixelTypes;
    currency?: string;
    value?: string;
    content_ids?: string;
    content_name?: string;
    content_type?: string;
};

export enum EPixelTypes {
    addPaymentInfo = 'AddPaymentInfo',
    addToCart = 'AddToCart',
    addToWishlist = 'AddToWishlist',
    completeRegistration = 'CompleteRegistration',
    contact = 'Contact',
    customizeProduct = 'CustomizeProduct',
    donate = 'Donate',
    findLocation = 'FindLocation',
    initiateCheckout = 'InitiateCheckout',
    lead = 'Lead',
    purchase = 'Purchase',
    schedule = 'Schedule',
    search = 'Search',
    startTrial = 'StartTrial',
    submitApplication = 'SubmitApplication',
    subscribe = 'Subscribe',
    viewContent = 'ViewContent',
}

export type AnalyticsSettingsFormControls = {
    googleAnalytic: FormControl<AnalyticsSettings['googleAnalytic']>;
    googleAnalyticAfterPayment: FormControl<AnalyticsSettings['googleAnalyticAfterPayment']>;
    pixelAnalytic: FormControl<AnalyticsSettings['pixelAnalytic']>;
    pixelAnalyticAfterPayment: FormControl<AnalyticsSettings['pixelAnalyticAfterPayment']>;
    googleSettings: GoogleSettingsFormGroupType;
    pixelSettings: PixelSettingsFormGroupType;
};

export type GoogleSettingsFormType = {
    category: FormControl<GoogleSettings['category']>;
    action: FormControl<GoogleSettings['action']>;
    label: FormControl<GoogleSettings['label']>;
    currency?: FormControl<GoogleSettings['currency']>;
    value?: FormControl<GoogleSettings['value']>;
    leadSource?: FormControl<GoogleSettings['leadSource']>;
};

export type PixelSettingsFormType = {
    type: FormControl<PixelSettings['type']>;
    typeAfterPayment?: FormControl<PixelSettings['typeAfterPayment']>;
};

export type AnalyticsSettingsFormGroupType = FormGroup<AnalyticsSettingsFormControls>;

export type GoogleSettingsFormGroupType = FormGroup<GoogleSettingsFormType>;

export type PixelSettingsFormGroupType = FormGroup<PixelSettingsFormType>;

export type PaymentGoogleSettings = {
    currency: string;
    value: number;
    productName?: string;
    items?: Array<{ item_name?: string }>;
};

export type GASettingsWithParams = {
    action: GaActionTypes;
    params?: {
        [key: string]: string | number;
    };
};

export enum GaActionTypes {
    'begin_checkout' = 'begin_checkout',
    'add_to_cart' = 'add_to_cart',
    'view_item' = 'view_item',
}
